
export const parseCSV = (text, filters) => {
  const pinCodeRegex = /^[1-9][0-9]{5}$/
  const lines = text.split('\n');
  const result = new Map();
  const headers = lines[0]
    .split(',')
    .map(header => header.trim().replace(/[^a-zA-Z0-9 ]/g, ''));
  headers.forEach(header => {
    if (!filters.headers.includes(header)) {
      throw new Error(filters.errorMessage);
    }
  });
  for (let i = 1; i < lines.length; i += 1) {
    const currentline = lines[i].split(',');
    if (!pinCodeRegex.test(currentline[0]?.trim())) {
      throw new Error(`${currentline[0]?.trim()} Pincode is Invalid`);
    }
    for (let j = 0; j < headers.length; j += 1) {
      if (result.has(headers[j])) {
        result.set(headers[j], [
          ...result.get(headers[j]),
          currentline[j]?.trim(),
        ]);
      } else {
        result.set(headers[j], [currentline[j]?.trim()]);
      }
    }
  }
  const pinCodes = Object.fromEntries(result.entries())
  const pinCodeSet = new Set(pinCodes.pinCode)
  if (pinCodeSet.size !== pinCodes?.pinCode?.length) {
    throw new Error(`Please remove duplicate pincodes`);
  }
  return pinCodes;
};

export const getFormattedCodData = pinCodeData => {
  if (pinCodeData.length === 0) return {};

  return pinCodeData.reduce(
    (a, c) => ({ ...a, [c.rule]: c.isActive ? c.configValue : '' }),
    {},
  );
};

export const getFormattedCodDataForAmount = obj => {
  const formattedObj = [...obj];
  formattedObj.push(true);
  if (formattedObj[0] === 'COD_ORDER_MAXIMUM_AMOUNT') {
    if (!formattedObj[1]) {
      formattedObj[1] = Number.MAX_SAFE_INTEGER / 1000;
      formattedObj[2] = false;
    }
  } else if (formattedObj[0] === 'COD_ORDER_MINIMUM_AMOUNT') {
    if (!formattedObj[1]) {
      formattedObj[1] = 0;
      formattedObj[2] = false;
    }
  }
  return formattedObj;
};
